// Drop/Quick-add zone geometry around a tree node (shared by Story F and B).
//
// Each main tree node card is 120 × 90px centered on (node.x, node.y).
// We expose 4 zones around the card:
//   - top    → "this node becomes parent"
//   - right  → "spouse" (alliance)
//   - left   → "spouse" (alliance)
//   - bottom → "child"
//
// QUICK_ADD_OFFSETS = relative pixel offsets where the "+" anchor sits.

// Offsets sit close to the card edges (60 × 45) — just outside the border so
// the "+" feels attached to the node. The collapse button now lives INSIDE
// the card so bottom can sit right at the card edge.
export const QUICK_ADD_OFFSETS = {
  top:    { dx: 0,   dy: -58 },
  right:  { dx: 74,  dy: 0 },
  left:   { dx: -74, dy: 0 },
  bottom: { dx: 0,   dy: 58 }
}

export const RELATION_FOR_ZONE = {
  top:    'parent',
  right:  'spouse',
  left:   'spouse',
  bottom: 'child'
}

// Iterate the 4 zones of a node (used by renderer to draw quick-add buttons).
export function eachQuickAddZone(callback) {
  for (const zone of Object.keys(QUICK_ADD_OFFSETS)) {
    callback(zone, QUICK_ADD_OFFSETS[zone], RELATION_FOR_ZONE[zone])
  }
}
